var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-root"},[_c('router-view'),_c('div',{staticClass:"info-cookie"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }